module.exports = __webpack_public_path__ + "static/media/Left.0035219c.svg";